import { __ } from '~/locale';

export const RESOURCE_TYPES = {
  GROUP: 'group',
  PROJECT: 'project',
};

export const SORT_LABEL_NAME = __('Name');
export const SORT_LABEL_CREATED = __('Created date');
export const SORT_LABEL_UPDATED = __('Updated date');
export const SORT_LABEL_STARS = __('Stars');
export const SORT_LABEL_STORAGE_SIZE = __('Storage size');

export const FILTERED_SEARCH_TOKEN_LANGUAGE = 'language';
export const FILTERED_SEARCH_TOKEN_MIN_ACCESS_LEVEL = 'min_access_level';
export const FILTERED_SEARCH_TOKEN_VISIBILITY_LEVEL = 'visibility_level';
export const FILTERED_SEARCH_TOKEN_NAMESPACE = 'namespace_path';

export const SORT_DIRECTION_ASC = 'asc';
export const SORT_DIRECTION_DESC = 'desc';

export const PAGINATION_TYPE_KEYSET = 'paginationKeyset';
export const PAGINATION_TYPE_OFFSET = 'paginationOffset';

export const QUERY_PARAM_PAGE = 'page';
